import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const TextKeywordImage = props => (
    <SvgIcon {...props}>
        <path
            d="M8.21 2.26c3.674 0 6.713 1.846 7.79 4.472v4.252l-.026.064a6.072 6.072 0 01-1.36 2.037l-.04.04.162 2.871-.044.002h-2.673l-1.613-.667c-.721.161-1.458.245-2.197.251C3.683 15.582 0 12.564 0 8.855 0 5.157 3.606 2.26 8.21 2.26zm3.483 2.68h-1.424a.119.119 0 00-.083.035L7.33 7.82a2.149 2.149 0 101.603 1.602l.473-.483a.119.119 0 00.034-.083v-.83h.83a.119.119 0 00.119-.12v-.83h.83a.119.119 0 00.084-.035l.475-.474a.119.119 0 00.034-.084V5.059a.119.119 0 00-.118-.118zM6.745 9.323a.685.685 0 110 1.37.685.685 0 010-1.37z"
            stroke="none"
            fillRule="nonzero"
        />
    </SvgIcon>
);

export default TextKeywordImage;
